import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { blue } from '@mui/material/colors';
import Button from '@mui/material/Button';

export interface IndicatorButtonProps {
  label: string
  onClick: () => void;
  loading: boolean;
  disabled?: boolean;
  size?: 'large' | 'small';
  variant?: 'contained' | 'outlined'
}

export function IndicatorButton(props: IndicatorButtonProps) {
  const { label, onClick, loading, disabled, variant, size } = props;

  return (
    <Box sx={{ m: 1, position: 'relative' }}>
      <Button
        variant={variant ?? 'contained' }
        disabled={loading || disabled}
        onClick={onClick}
        size={size}
      >
        {label}
      </Button>
      {loading && (
        <CircularProgress
          size={24}
          sx={{
            color: blue[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      )}
    </Box>
  );
}